import {
  AirLocationTypeEnum,
  AirSelectedItineraryResponseManager,
  FlightDetailsInfoType,
  IAirSuggestion,
  IFlightSearchSegmentState,
} from 'obt-common';

interface Input {
  segments: IFlightSearchSegmentState<IAirSuggestion[]>[];
  airSelectedItineraryResponseManager: AirSelectedItineraryResponseManager;
}

export const getSegmentsWithSelectedAirSuggestion = ({
  segments,
  airSelectedItineraryResponseManager,
}: Input): IFlightSearchSegmentState<IAirSuggestion>[] => {
  return segments.map((segment, segmentIndex) => {
    const flightDetails = airSelectedItineraryResponseManager
      .GetLegFlightDetailsForSelectedItinerary(segmentIndex)
      .filter((flight) => flight.type === FlightDetailsInfoType.FLIGHT);

    const originAirSuggestion: IAirSuggestion = {
      type: AirLocationTypeEnum.AIRPORT,
      code: flightDetails[0].data.departureAirport,
      name: flightDetails[0].data.departureAirportName,
      city: flightDetails[0].data.departureAirportCity,
      countryCode: flightDetails[0].data.departureCountryCode,
    };
    const destinationAirSuggestion: IAirSuggestion = {
      type: AirLocationTypeEnum.AIRPORT,
      code: flightDetails[flightDetails.length - 1].data.arrivalAirport,
      name: flightDetails[flightDetails.length - 1].data.arrivalAirportName,
      city: flightDetails[flightDetails.length - 1].data.arrivalAirportCity,
      countryCode: flightDetails[flightDetails.length - 1].data.arrivalCountryCode,
    };
    return {
      ...segment,
      origin: originAirSuggestion,
      destination: destinationAirSuggestion,
    };
  });
};
